import withStyles from '@mui/styles/withStyles';
import Badge from '@mui/material/Badge';

export const admissionViewTypes = {
    MDU: 'MDU',
    THEATRES: 'TCI',
};

export const admissionStatusTypes = {
    WORKLIST: 'Worklist',
    UNSCHEDULED: 'Unscheduled',
    SCHEDULED: 'Scheduled',
};

export const SessionsTime = {
    AM: 'am',
    PM: 'pm',
    TW: 'twighlight',
    AD: 'all',
};

export const CalendarViews = {
    days1: 'days1',
    days4: 'days4',
    days5: 'days5',
    days7: 'days7',
    month: 'month',
};

export const contentViewTypes = {
    SCHEDULE: 'SCHEDULE',
    INFORMATION: 'INFORMATION',
};

export const StyledBadgeAdmission = withStyles((theme) => ({
    badge: {
        right: 1,
        top: 1,
        padding: '0 4px',
    },
    dot: {},
}))(Badge);

export const StatusTypes = {
    ACTIVE: 'active',
    CANCELED: 'canceled',
};

export const StatusReschedule = {
    ASSIGNED: 'assigned',
    UNASSIGNED: 'unassigned',
};

export const InformationTab = {
    FORM: 'form',
    DECISIONS: 'decisions',
    CONTACT_HISTORY: 'contactHistory',
};